import { render, staticRenderFns } from "./DadosComunicacaoTransferencia.vue?vue&type=template&id=7ad9a332&scoped=true&"
import script from "./DadosComunicacaoTransferencia.vue?vue&type=script&lang=js&"
export * from "./DadosComunicacaoTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./DadosComunicacaoTransferencia.vue?vue&type=style&index=0&id=7ad9a332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad9a332",
  null
  
)

export default component.exports